import { schema } from 'normalizr';

export const safecosmeticDashboardSchema = new schema.Entity('safecosmeticDashboard', {}, { idAttribute: 'ProductId' });

export const safecosmeticDashboardListSchema = [safecosmeticDashboardSchema];
